import styles from './discussions.module.css'

import * as React from 'react'

import type { DiscussionVisibility } from 'types/discussion'
import type { TrackId } from 'types/track'

import { Box, DiscoCallout, SegmentedControl } from 'components/ds'

import CommentEditor from './comment-editor'

type Props = {
  trackIds: TrackId[]
  visibility: DiscussionVisibility
  onVisibilityChange: (visibility: DiscussionVisibility) => void
}

const BulkTrackDiscussions = ({
  trackIds,
  visibility,
  onVisibilityChange,
}: Props): React.ReactElement => {
  return (
    <Box width="100%">
      <SegmentedControl.Root
        value={visibility}
        onValueChange={v => onVisibilityChange(v as DiscussionVisibility)}
        className={styles.tabsRoot}
      >
        <SegmentedControl.Item value="internal">
          Internal Notes
        </SegmentedControl.Item>
        <SegmentedControl.Item value="client">
          External Notes
        </SegmentedControl.Item>
      </SegmentedControl.Root>
      <Box my="4">
        <DiscoCallout type="info">
          {`You are editing ${trackIds.length} tracks. Newly created notes will be added to all selected tracks.`}
        </DiscoCallout>
      </Box>
      <Box pt="3">
        <CommentEditor
          key={visibility}
          mode="bulk-create"
          trackIds={trackIds}
          visibility={visibility}
        />
      </Box>
    </Box>
  )
}

export default BulkTrackDiscussions
